import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './i18n'; // Import i18n initialization
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import PostDetail from './pages/PostDetail';
import About from './pages/About';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Footer from './components/Footer';
import ProfileManagement from './pages/ProfileManagement';
import NotFound from './pages/NotFound';
import DashboardTraffic from './pages/DashboardTraffic';
import MarkdownTest from './components/MarkdownTest';

const AppContent = () => {
  const { getThemeClass } = useTheme();
  
  return (
    <Router>
      <div className={`terminal-theme ${getThemeClass()}`}>
        <Navbar />
        <main className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/blog" element={<Home />} />
            <Route path="/home" element={<Navigate to="/blog" replace />} />
            <Route path="/posts/:slug" element={<PostDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <ProfileManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/dashboard/traffic" 
              element={
                <ProtectedRoute>
                  <DashboardTraffic />
                </ProtectedRoute>
              } 
            />
            {/* Temporary test route */}
            <Route path="/test-markdown" element={<MarkdownTest />} />
            {/* Catch-all route for 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#ede9fe',
              color: '#6d28d9',
              border: '1px solid #c4b5fd',
            },
          }}
        />
        <Footer />
      </div>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App; 